import Box from '@common/components/Box';
import GuidedTourPopupComponent from '@common/components/GuidedTourPopup/GuidedTourPopupComponent';
import IconSpinner from '@common/components/svgs/common/Spinner';

function GuidedTourPopupLoading() {
  return (
    <GuidedTourPopupComponent>
      <Box className="txt-center" my={4} py={16}>
        <IconSpinner size={24} />
      </Box>
    </GuidedTourPopupComponent>
  );
}

export default GuidedTourPopupLoading;
